import type { FlightLeg } from '../../../domain/types'
import { Tag } from '@sunwebgroup/uds-ui/tag'
import { useIntl } from '@/intl'
import {
  formatStopoverDuration,
  getStopoverDurationMinutes,
} from '../../utils/flightDetails'
import styles from './FlightStopover.module.css'

const FLIGHT_STOPOVER_TRANSLATION_KEY = 'booking_details_flight_stopover'

interface FlightStopoverProps {
  previousLeg: FlightLeg
  nextLeg: FlightLeg
}

export function FlightStopover({ previousLeg, nextLeg }: FlightStopoverProps) {
  const { formatMessage } = useIntl()
  const durationMinutes = getStopoverDurationMinutes(previousLeg, nextLeg)

  if (durationMinutes === null) {
    return null
  }

  const duration = formatStopoverDuration(durationMinutes, formatMessage)

  return (
    <div className={styles.stopover} role="group" aria-label={formatMessage({ id: FLIGHT_STOPOVER_TRANSLATION_KEY }, { duration })}>
      <span className={styles.line} aria-hidden="true" />
      <Tag size="M" variant="neutral-tinted" icon="Clock">
        {formatMessage({ id: FLIGHT_STOPOVER_TRANSLATION_KEY }, { duration })}
      </Tag>
      <span className={styles.line} aria-hidden="true" />
    </div>
  )
}
